/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Page Photo',
  definitions: {
    '48': {
      viewBox: '0 0 48 48',
      path: (
        <>
          <path
            fill="currentColor"
            fillRule="evenodd"
            d="M26.683 16.324c-1.787 0-3.274 1.404-3.274 3.182s1.487 3.182 3.274 3.182 3.274-1.404 3.274-3.182-1.487-3.182-3.274-3.182zm-2.024 3.182c0-1.046.885-1.932 2.024-1.932s2.024.886 2.024 1.932-.885 1.932-2.024 1.932-2.024-.886-2.024-1.932zM7.375 11.5c0-.621.504-1.125 1.125-1.125h31c.621 0 1.125.504 1.125 1.125v25c0 .621-.504 1.125-1.125 1.125h-31c-.621 0-1.125-.504-1.125-1.125v-25zm1.25.125v11.22l3.568-3.444a2.74 2.74 0 0 1 3.777 0l10.894 10.516L32.3 24.67a2.74 2.74 0 0 1 3.777 0l3.298 3.184V11.625H8.625zm30.75 17.965l-4.197-4.052c-.546-.527-1.432-.527-1.979 0l-6.335 6.115-11.793-11.384c-.546-.527-1.432-.527-1.979 0l-4.467 4.312v11.794h30.75V29.59zM3.375 9C3.375 7.55 4.55 6.375 6 6.375h36c1.45 0 2.625 1.175 2.625 2.625v30c0 1.45-1.175 2.625-2.625 2.625H6c-1.45 0-2.625-1.175-2.625-2.625V9zM6 7.625c-.759 0-1.375.616-1.375 1.375v30c0 .759.616 1.375 1.375 1.375h36c.759 0 1.375-.616 1.375-1.375V9c0-.759-.616-1.375-1.375-1.375H6z"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
